import React from 'react'

export const useMainQueryKey = () =>
  React.useMemo(() => ['BrandAccountsListPage_Main'], [])
